import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { AllCategoriesMiniEntity } from '../../domain/entities/AllCategoriesMiniEntity'

export class AllCategoriesMiniModel extends AllCategoriesMiniEntity {
  constructor(dataDto: AllCategoriesMiniEntity) {
    super()
    mapEntityProperties<AllCategoriesMiniModel>(this, dataDto)
  }
}
